import React, { Component } from "react";
import {Row,Col,Button,Modal} from "react-bootstrap";

class ChemistActive extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  Submit = () => {
    let value = this.props.ChemistActiveDtls;
    this.props.ChemistInActive(value);
    this.props.handleClose();
    this.props.resetPage();
  };

  render() {
    const data =
      this.props.ChemistActiveDtls && this.props.ChemistActiveDtls.item
        ? this.props.ChemistActiveDtls && this.props.ChemistActiveDtls.item
        : null;

    return (
      <div>
        <div className="userModalDiv">
          <Modal
            show={this.props.show}
            onHide={this.props.handleClose}
            animation={false}
            size="md"
            backdrop="static"
            centered={true}
            // className="modal-backdrop fade show"
          >

            {data !== null && data.status === "suspended" ? (
              <Modal.Body>
                <div>
                  <h6 style={{ textAlign: "center", marginTop: "20px" }}>
                    <b>Change the chemist profile status to "Active" ?</b>
                  </h6>
                </div>
                <Row style={{ marginTop: "30px", marginBottom: "20px" }}>
                  <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                    <Button
                      variant="danger"
                      className="cmnDelCnclBtn"
                      onClick={() => this.props.handleClose()}
                    >
                      CANCEL
                    </Button>
                  </Col>
                  <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                    <Button
                      variant="success"
                      className="cmnDelOkBtn"
                      onClick={this.Submit}
                    >
                      OK
                    </Button>
                  </Col>
                </Row>
              </Modal.Body>
            ) : (
              <Modal.Body>
                <div>
                  <h6 style={{ textAlign: "center", marginTop: "20px" }}>
                    <b>Suspend the chemist profile?</b>
                  </h6>
                </div>
                <Row style={{ marginTop: "30px", marginBottom: "30px" }}>
                  <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                    <Button
                      variant="danger"
                      className="cmnDelCnclBtn"
                      onClick={() => this.props.handleClose()}
                    >
                      CANCEL
                    </Button>
                  </Col>
                  <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                    <Button
                      variant="success"
                      className="cmnDelOkBtn"
                      onClick={this.Submit}
                    >
                      OK
                    </Button>
                  </Col>
                </Row>
              </Modal.Body>
            )}
          </Modal>
        </div>
      </div>
    );
  }
}

export default ChemistActive;
